import { render, staticRenderFns } from "./SectionSolution.vue?vue&type=template&id=208c0a5e&scoped=true"
import script from "./SectionSolution.vue?vue&type=script&lang=ts"
export * from "./SectionSolution.vue?vue&type=script&lang=ts"
import style0 from "./SectionSolution.vue?vue&type=style&index=0&id=208c0a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c0a5e",
  null
  
)

export default component.exports